import { clubCapturaEsteTorneo } from './torneoOrigen'

// Filtro puro: de una lista de torneos, en cuales puede el club crear un juego.
//
// La lista entra desde afuera (los torneos del club) y NO se deriva de los juegos
// existentes: un torneo recien creado todavia no tiene ninguno, y derivarla dejaba su
// primer juego imposible de capturar.
//
// El criterio es "el club captura aqui" (clubCapturaEsteTorneo), no "es mio" (exigir que
// la organizadora sea el club): un torneo interno no tiene organizadora y el club lo
// lleva entero.
export const torneosParaCrearJuego = (torneos = [], orgId = null) => {
  if (!orgId) return []
  const porId = new Map()
  ;(torneos || []).forEach((torneo) => {
    if (torneo?.id && !porId.has(torneo.id)) porId.set(torneo.id, torneo)
  })
  return Array.from(porId.values()).filter((torneo) => {
    if ((torneo.estatus || '').toLowerCase() === 'cancelado') return false
    // Un torneo archivado es historial de solo lectura (mismo criterio que esArchivado
    // en components/torneos/torneoStatus.js; no se importa desde aqui para no hacer que
    // lib/ dependa de components/).
    if (torneo.activo === false) return false
    return clubCapturaEsteTorneo(torneo, orgId)
  })
}
